export default __webpack_public_path__ + "static/media/BOP_PandleFirstBank_logo.de233614.png";